<template>
    <div id="main">
        <div class="platform-header">
            <div class="platform-logo-container">
                <img class="platform-logo-container__logo" src="https://cdnfile-10043692.file.myqcloud.com/heartsOfRiver/heartsOfRiverLogo.png"/>
                <div class="title platform-logo-container__title">江北心e站&nbsp;&nbsp;家校直通车</div>
            </div>
            <div class="platform-top-nav">
                <ul class="nav_item_container clearfix">
                </ul>
            </div>
            <div class="platform-user">
                <el-dropdown trigger="click">
                    <div class="platform-user__avatar-container">
                        <div class="platform-user__avatar-inner clearfix"><img
                            :src="userInfo.avatar"
                            class="platform-user__avatar">
                            <div class="platform-user__name">
                                {{userInfo.name}}
                            </div>
                            <i class="el-icon-caret-bottom"></i>
                        </div>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <span style="display:block;"  @click="logout">退出登录</span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="platform-nav">
            <div class="nav-bar__welcome">欢迎您，{{userInfo.name}}</div>
            <div class="nav-item-container">
                <div class="nav-item" @click="jumpToPage('/main/affairs')">
                    <div class="icon icon--nav-1"></div>
                    <div>信息处理</div>
                </div>
                <div class="nav-item" @click="jumpToPage('/main/accounting')" v-if="checkIndexPermission(permission, '/throughTrain/getTrainTypeStatisticalList')">
                    <div class="icon icon--nav-2"></div>
                    <div>数据统计</div>
                </div>
                <div class="nav-item" @click="jumpToPage('/main/setting')" v-if="checkIndexPermission(permission, '/throughTrain/addTrainType')">
                    <div class="icon icon--nav-3"></div>
                    <div>系统设置</div>
                </div>
            </div>
        </div>
        <div class="module-container">
            <div class="module-container__inner">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
    import baseMixin from '@/mixins/baseMixin.js'
    import {mapGetters} from 'vuex';

    export default {
        name: "Main",
        mixins: [baseMixin],
        data() {
            return {}
        },
        computed: {
            ...mapGetters(['userInfo', 'permission'])
        },
        created() {
            console.log(this.$route);
        },
        methods: {
            logout() {
                this.$store.dispatch('LogOut').then(() => {
                    // location.reload();// 为了重新实例化vue-router对象 避免bug
                    this.$router.push('/login')
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
<style lang="scss">
    @import "../../../commonsPC/styles/mixins";
    @import "../../../commonsPC/styles/platform-global";
    @include reset-global;

    .platform-header {
        @include platform-header;

        .platform-logo-container {
            @include platform-logo-container;
        }
        .platform-top-nav {
            @include platform-top-nav;

        }
        .platform-user {
            @include platform-user;
        }
    }
    .platform-nav {
        @include platform-nav;
        .icon.icon--nav-1 {
            background-image: url(../assets/images/nav-icon2.png);
        }

        .icon.icon--nav-2 {
            background-image: url(../assets/images/nav-icon3.png);
        }

        .icon.icon--nav-3 {
            background-image: url(../assets/images/nav-icon4.png);
        }

        .icon.icon--nav-4 {
            background-image: url(../assets/images/nav-icon1.png);
        }
        .icon.icon--nav-5 {
            background-image: url(../assets/images/nav-icon1.png);
        }
    }

    .platform-logo-container__title {
        margin-left: 20px;
    }
    .module-container {
        margin-top: 200px;
        box-sizing: border-box;
        padding: 25px 5%;
        min-width: 1380px;
        background-color: #F1F1F1;
        .module-container__inner {
            background-color: #fff;
        }
    }

    html {
        overflow-y: hidden;
        background-color: #F1F1F1;
    }
</style>



// WEBPACK FOOTER //
// src/views/Main.vue